import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=e288314a"
import script from "./Sorting.vue?vue&type=script&lang=ts"
export * from "./Sorting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e288314a')) {
      api.createRecord('e288314a', component.options)
    } else {
      api.reload('e288314a', component.options)
    }
    module.hot.accept("./Sorting.vue?vue&type=template&id=e288314a", function () {
      api.rerender('e288314a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/Sorting.vue"
export default component.exports